import React, {Component} from "react"
import PropTypes from "prop-types"
import moment from "moment-timezone"

import id from "@irati/utils/id"
import Validation from "@irati/utils/validation"
import DatePicker from "@irati/ui/src/FormItem/DatePicker"
import {injectIntl} from "@irati/utils/lang"


export const PROPERTY = "nextTriggerAtOverride"
export const schema = (formatMessage) => Validation.date(formatMessage({id: "insights.schedule.nextTriggerAtOverride.dateValidation"}))

class NextTriggerAtOverride extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    name: PROPERTY,
    label: "Next survey start date",
    hint: null,
    disabled: false
  }

  handleChange = (value) => {
    /** Dispatch changes */
    const {onChange, schedule, name} = this.props
    onChange(schedule, name, value.clone().utc().format())
  }

  getValue = () => {
    const {nextTriggerAtOverride, nextTriggerAt} = this.props.schedule

    if (nextTriggerAtOverride) return moment(nextTriggerAtOverride)

    return moment(nextTriggerAt)
  }


  render() {
    const idNamespace = id("StartAt", this.props)
    const {name, label, formatMessage, disabled} = this.props

    return (
      <DatePicker
        disabled={disabled}
        id={idNamespace}
        label={formatMessage({id: label})}
        name={name}
        showTimeSelect
        value={this.getValue()}
        onChange={this.handleChange}
        minDate={moment()}
        validation={schema(formatMessage)} />
    )
  }
}

export default injectIntl(NextTriggerAtOverride)
